// 引入公共模块
import { 
  mergeParams,
  addParamsToLinksHandler,
  pageJumpHandler,
  pageJumpBlankHandler,
  initScrollHandler,
  initNavBarHandler,
} from './common.js';

// 命名空间模式
const App = {
  init() {
    addParamsToLinksHandler(mergeParams()); //为链接添加参数
    pageJumpHandler(); //页面跳转
    pageJumpBlankHandler(); // 页面跳转(新窗口打开)
    initScrollHandler(); // 滚动处理
    initNavBarHandler(); // 导航下拉处理
    this.serviceTabHandler(); // 服务共建Tab 
    this.capabilityHandler(); // 技能共建 
  },
  serviceTabHandler() {
    $('.service-co-construction-tab-item').on('mouseenter', function(e){
        // 阻止默认的点击行为
        e.preventDefault();
        const $this = $(this);
        const tag = $this.attr('data-tag')

        // 1. 切换tab激活态
        $this.addClass('active').siblings().removeClass('active');

        // 2. 根据下标，给对应内容项加active，其他移除
        $('.service-co-construction-content-item').removeClass('active');
        $(`.service-co-construction-content-item[data-tag="${tag}"]`).addClass('active');
    })
  },
  capabilityHandler() {
    const $compare = $('.capability-co-construction-container');
    const $left = $compare.find('.capability-card-left');
    const $right = $compare.find('.capability-card-right');

    $left.on('mouseenter', function () {
        $compare.removeClass('swapped');
    });
    $right.on('mouseenter', function () {
        $compare.addClass('swapped');
    });
  }
};

// 文档加载后初始化
$(function () {
  App.init();
});
